import React, { useState } from 'react';
import QuestionAnswer from './QuestionAnswer';
import { TopFAQ } from './IFaq';

const FiveFAQSection: React.FC<TopFAQ> = ({ faqs }) => {
  const [openId, setOpenId] = useState<string | null>(null);

  const handleToggle = (id: string) => {
    setOpenId((prev) => (id === prev ? null : id));
  };

  return (
    <div className="flex flex-1 flex-col gap-6">
      <h2
        className="font-inter font-avantgarde text-[16px] sm:text-[22px]
      sm:leading[33px] leading-[24px] text-blue-900 font-bold mt-[10px] "
      >
        Top 5 veelgestelde vragen
      </h2>
      {faqs?.map((faq, index) => (
        <QuestionAnswer
          key={faq.faqId}
          handleToggle={(elmId: string) => handleToggle(elmId)}
          openId={openId}
          faq={faq}
          containerStyle={`rounded pb-[24px] border-stone-100 ${
            index === faqs.length - 1 ? 'border-b-0' : 'border-b-2'
          }`}
        />
      ))}
    </div>
  );
};
export default FiveFAQSection;
